// extracted by mini-css-extract-plugin
export var accordion = "accordion-dr-module--accordion--ad5ce";
export var headlineSizeSmall = "accordion-dr-module--headline-size-small--cf6a7";